import { Snackbar, SnackbarProps } from '@mui/material';
import './ccf-snack-bar.module.scss';

/* eslint-disable-next-line */
export interface CcfSnackBarProps extends SnackbarProps {}

/**
 * This is wraaper component for material UI snackbar component/ toast
 * @param props -CcfSnackBarProps
 * @returns material ui snack bar component
 * @example <CcfSnackBar/>
 */
export function CcfSnackBar({children,...other}: CcfSnackBarProps) {
  return (
    <Snackbar {...other}>
      {children}
    </Snackbar>
  );
}

export default CcfSnackBar;
